import httpService from 'services/httpService'

const BASE_URL = 'https://www.cultivointeligente.com.br/'

export const getPrivacyPolicy = async (params) => {
  return await httpService.get(BASE_URL + 'api/v4/privacy_policies/get_privacy_policy', { params })
}
